import { render, staticRenderFns } from "./layout-foot.vue?vue&type=template&id=1c26e3ef&scoped=true"
import script from "./layout-foot.vue?vue&type=script&lang=js"
export * from "./layout-foot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c26e3ef",
  null
  
)

export default component.exports